// extracted by mini-css-extract-plugin
export default {"headerInputContainer":"CampaignNameInput_headerInputContainer__HwAnH","close":"CampaignNameInput_close__QHU+O"};